module.exports = __webpack_public_path__ + "static/media/access-revoked-404.4780a14c.svg";